<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-09-25 10:42:32
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-19 10:12:52
 * @FilePath: /b2c_public_components/src/zz-new-report/src/battery-popup.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="battery-wrapper">
    <div v-for="(item, index) in explainTexts" :key="index" class="battery-item">
      <span v-if="item.title" class="battery-item_title">{{ item.title }}</span>
      <span v-if="item.text" class="battery-item_text">{{ item.text }}</span>
      <div v-for="(sub, i) in item.explainSubTexts" :key="i" class="battery-item_imgs">
        <p v-if="sub.subTitle" class="sub_title">{{ sub.subTitle }}</p>
        <div
          class="img_list"
          :class="{ img_list_active: id == 1 && sub.extContent && sub.extContent.length == 3 }"
        >
          <img
            v-for="(img, idx) in sub.extContent"
            :key="idx"
            :src="$setPicSize(img)"
            alt=""
            @click="imgClick(sub.extContent, idx)"
          />
        </div>
        <div v-if="sub.texts && sub.texts.length" class="text_list">
          <p v-for="(text, t) in sub.texts" :key="t" class="text">{{ text }}</p>
        </div>
      </div>
    </div>
    <section v-show="showFeedback && feedbackVal" class="feed-back">
      <z-platform-bch-entry
        position="right"
        type="bottom"
        questionnaireId="1647862956798513664"
        :canBack="1"
        :openType="3"
        :outAppOpenType="2"
        getContainer="body"
        :extend="{
          pageName: '电池换新服务',
          ...feedbackData,
        }"
      />
    </section>
  </div>
</template>
<script>
  import { PlatformBchEntry } from '@zz-common/zz-ui'
  import { setPicSize } from '@zz-common/zz-utils'
  import { hasSupportFeature, browserLuxuryImages, isPlatform } from '../../utils/native'
  import { previewImgClick } from '../../utils/useBigImages'
  export default {
    components: {
      [PlatformBchEntry.name]: PlatformBchEntry,
    },
    data() {
      return {
        feedbackVal: true, //组件给的是否展示入口的回调值
      }
    },
    props: {
      explainTexts: {
        type: Array,
        default: () => [],
      },
      id: {
        type: Number,
        default: 0,
      },
      showFeedback: {
        type: Boolean,
        default: false,
      },
      feedbackData: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
    methods: {
      imgClick(tabList, selectedIndex) {
        const len = tabList.length
        if (len !== 3) return false
        if (isPlatform('zz')) {
          const list = [
            {
              tabName: '概况',
              name: '实拍图',
              imgList: tabList,
            },
          ]
          hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
            if (res && res.code && res.code != '-1') {
              browserLuxuryImages({ selectedIndex, tabList: list })
            } else {
              previewImgClick(tabList, [], selectedIndex)
            }
          })
        } else {
          previewImgClick(tabList, [], selectedIndex)
        }
      },
      feedbackCallback(val) {
        this.feedbackVal = !!val
      },
    },
  }
</script>

<style lang="scss">
  .battery-wrapper {
    padding: 0 32px;
    height: calc(100% - 230px);
    overflow-y: scroll;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: border-box;
    .battery-item {
      display: flex;
      flex-direction: column;
      background: #f8f8f8;
      border-radius: 16px;
      padding: 46px 32px;
      margin-bottom: 20px;
      &_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 32px;
      }
      &_text {
        margin-top: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
      }
      &_imgs {
        .img_list {
          margin-top: 24px;
          img {
            width: 622px;
            display: block;
          }
          &.img_list_active {
            display: flex;
            justify-content: space-between;
            img {
              width: 200px;
              height: 285px;
            }
          }
        }
        .sub_title {
          margin-top: 36px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 24px;
        }
        .text_list {
          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 40px;
          }
        }
      }
    }
    .feed-back {
      margin-top: 95px;
      padding-bottom: 24px;
    }
  }
</style>
